import apiRequest from './api';

/**
 * Create new employee
 */
export const createEmployee = async (employeeData) => {
  return await apiRequest('/admin/employees', {
    method: 'POST',
    body: JSON.stringify(employeeData),
  });
};

/**
 * Get all employees
 */
export const getAllEmployees = async () => {
  return await apiRequest('/admin/employees');
};

export const getEmployeeById = async (id) => {
  return await apiRequest(`/admin/employees/${id}`);
};

export const getAllEmployeesForUser = async () => {
  return await apiRequest('/employee/peers');
};

/**
 * Update employee salary
 */
export const updateEmployeeSalary = async (employeeId, salary) => {
  return await apiRequest(`/admin/employees/${employeeId}/salary`, {
    method: 'PUT',
    body: JSON.stringify({ salary }),
  });
};

/**
 * Update employee work hours
 */
export const updateEmployeeWorkHours = async (employeeId, workHours) => {
  return await apiRequest(`/admin/employees/${employeeId}/work-hours`, {
    method: 'PUT',
    body: JSON.stringify({ workHours }),
  });
};

/**
 * Update employee profile photo
 */
export const updateEmployeePhoto = async (employeeId, profilePhoto) => {
  return await apiRequest(`/admin/employees/${employeeId}/photo`, {
    method: 'PUT',
    body: JSON.stringify({ profilePhoto }),
  });
};

/**
 * Assign task to employee
 */
export const assignTask = async (taskData) => {
  return await apiRequest('/admin/tasks', {
    method: 'POST',
    body: JSON.stringify(taskData),
  });
};

/**
 * Get all tasks
 */
export const getAllTasks = async () => {
  return await apiRequest('/admin/tasks');
};

/**
 * Get employee time entries
 */
export const getEmployeeTimeEntries = async (employeeId, month, year, startDate, endDate) => {
  const params = new URLSearchParams();
  if (startDate && endDate) {
    params.append('startDate', startDate);
    params.append('endDate', endDate);
  } else {
    if (month) params.append('month', month);
    if (year) params.append('year', year);
  }

  return await apiRequest(`/admin/employees/${employeeId}/time-entries?${params.toString()}`);
};

export const changeUserPassword = async (userId, password) => {
  return await apiRequest(`/admin/employees/${userId}/password`, {
    method: 'PUT',
    body: JSON.stringify({ password })
  });
};

export const terminateEmployee = async (userId, reason) => {
  return await apiRequest(`/admin/employees/${userId}/terminate`, {
    method: 'PUT',
    body: JSON.stringify({ reason })
  });
};

export const reactivateEmployee = async (userId) => {
  return await apiRequest(`/admin/employees/${userId}/reactivate`, {
    method: 'PUT'
  });
};

export const promoteEmployee = async (userId, designation, remarks) => {
  return await apiRequest(`/admin/employees/${userId}/promote`, {
    method: 'PUT',
    body: JSON.stringify({ designation, remarks })
  });
};

export const getHolidays = async () => {
  return await apiRequest('/holidays');
};

export const createHoliday = async (data) => {
  return await apiRequest('/holidays', {
    method: 'POST',
    body: JSON.stringify(data)
  });
};

export const deleteHoliday = async (id) => {
  return await apiRequest(`/holidays/${id}`, {
    method: 'DELETE'
  });
};

export const withdrawHoliday = async (id, reason) => {
  return await apiRequest(`/holidays/${id}/withdraw`, {
    method: 'PUT',
    body: JSON.stringify({ reason })
  });
};

export const getAttendanceStats = async () => {
  return await apiRequest('/admin/stats');
};

export const paySalary = async (salaryData) => {
  return await apiRequest('/admin/payroll/pay', {
    method: 'POST',
    body: JSON.stringify(salaryData),
  });
};

export const saveDraftSalary = async (salaryData) => {
  return await apiRequest('/admin/payroll/draft', {
    method: 'POST',
    body: JSON.stringify(salaryData),
  });
};

export const sendSalaryEmail = async (data) => {
  return await apiRequest('/admin/payroll/send-email', {
    method: 'POST',
    body: JSON.stringify(data),
  });
};

export const getPayrollStatus = async (month, year) => {
  return await apiRequest(`/admin/payroll/status?month=${month}&year=${year}`);
};

export const getEmployeePayrollHistory = async (employeeId) => {
  return await apiRequest(`/admin/payroll/history/${employeeId}`);
};
export const getTimeChangeRequests = async () => {
  return await apiRequest('/admin/attendance/requests');
};

export const handleTimeChangeRequest = async (requestId, data) => {
  return await apiRequest(`/admin/attendance/requests/${requestId}`, {
    method: 'PUT',
    body: JSON.stringify(data)
  });
};

export const updateTimeEntry = async (data) => {
  return await apiRequest('/admin/attendance/manual-update', {
    method: 'POST',
    body: JSON.stringify(data)
  });
};

/**
 * Update employee details
 */
export const updateEmployeeDetails = async (employeeId, employeeData) => {
  return await apiRequest(`/admin/employees/${employeeId}`, {
    method: 'PUT',
    body: JSON.stringify(employeeData),
  });
};

export const getAllLeaves = async () => {
  return await apiRequest('/admin/leaves');
};

/**
 * Get daily work updates for a specific date
 */
export const getDailyWorkUpdates = async (date) => {
  return await apiRequest(`/admin/work-updates?date=${date}`);
};
